<div fxFlex="auto" fxLayout="column">
  <blockquote class="m-0 mb-4">
    <p>
      Lists all services already deployed on the device that have configuration conflicts with the
      new deployment.
    </p>
    <p>
      Expand a service to view affected devices, resource summaries, and individual resource
      conflicts.
    </p>
  </blockquote>
  <blockquote class="mx-2" *ngIf="jobs.length == 0; else showJobs">
    No conflicts or duplicates found
  </blockquote>
  <ng-template #showJobs>
    <ng-container *ngIf="jobs.length > 1; else singleJob">
      <div
        class="bg-app-bar px-6 h-16 border-b sticky left-0"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <h2
          class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l"
          fxFlex="none"
          fxHide.xs
        >
          <span>Services</span>
        </h2>
        <div
          class="bg-card rounded-full border px-4"
          fxFlex.lt-md="auto"
          fxHide.xs
          fxLayout="row"
          fxLayoutAlign="start center"
          style="width: 40%"
        >
          <ic-icon [icIcon]="icSearch" size="20px"></ic-icon>
          <input
            class="px-4 py-3 border-0 outline-none w-full bg-transparent"
            placeholder="Search by service name..."
            type="text"
            (input)="searchJobs($event.target.value)"
          />
        </div>
      </div>
      <table class="w-full mat-table">
        <thead>
          <tr class="mat-header-row">
            <th class="uppercase mat-header-cell align-left">Service Name</th>
            <th class="uppercase mat-header-cell align-left">Action</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let job of getJobs(); let jobIndex = index">
            <tr class="mat-row">
              <td class="mat-cell">
                <span class="primary">{{ job.Name }}</span>
              </td>
              <td class="mat-cell">
                <button
                  *ngIf="isNeedViewDiff"
                  class="mr-2"
                  mat-raised-button
                  color="primary"
                  type="button"
                  (click)="compareInventory(job)"
                >
                  View Diff
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  (click)="toggleExpandJob(jobIndex)"
                >
                  View Details
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{ expandedJobIndex === jobIndex ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>
              </td>
            </tr>
            <tr class="mat-row" *ngIf="expandedJobIndex === jobIndex">
              <td class="mat-cell" colspan="2">
                <ng-container
                  *ngTemplateOutlet="jobView; context: { $implicit: job, index: jobIndex }"
                ></ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
    <ng-template #singleJob>
      <ng-container
        *ngTemplateOutlet="jobView; context: { $implicit: jobs[0], index: 0 }"
      ></ng-container>
    </ng-template>
  </ng-template>
</div>

<ng-template #jobView let-job let-jobIndex="index">
  <div class="example-element-detail w-full" fxLayout="column">
    <inventory-card-full-width [inventory]="job" [isDriftedAndImportedShow]="false">
      <div rightHeaderContent fxLayout="row" fxLayoutAlign="end end">
        <div fxLayout="column">
          <button
            *ngIf="isNeedViewDiff"
            mat-raised-button
            color="primary"
            type="button"
            (click)="compareInventory(job)"
            class="mb-4"
          >
            View Diff
          </button>
          <!-- <mat-button-toggle-group>
            <mat-button-toggle value="Take Source">
              <mat-icon [icIcon]="icArrowBack"></mat-icon>
              Take Source
            </mat-button-toggle>
            <mat-button-toggle value="Take Target">
              <mat-icon [icIcon]="icArrowForward"></mat-icon>
              Take Target
            </mat-button-toggle>
            <mat-button-toggle value="Take Merge">
              <mat-icon [icIcon]="icSync2"></mat-icon>
              Take Merge
            </mat-button-toggle>
          </mat-button-toggle-group>-->
        </div> 
      </div>
      <div bottomContent fxLayout="row" *ngIf="isShowResourceLevelView">
        <div class="card bg-base mb-6 mx-6 w-full">
          <div class="border-b py-4 px-6" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0 title">Conflict Details for {{ job.Name }}</h2>
          </div>
          <div fxLayout="column" class="w-full p-gutter">
            <div fxFlex="auto" fxLayout="column">
              <blockquote class="m-0 mb-4">
                <p>
                  Review the list of devices and resources within this service that are impacted by
                  the current deployment. Choose how to resolve each conflict by applying new
                  changes (Source), keeping the deployed version (Target), or merging
                  configurations.
                </p>
              </blockquote>
              <div class="card w-full">
                <div class="border-b py-4 px-6" fxLayout="row" fxLayoutAlign="start center">
                  <h2 class="m-0 title">Resource Summary</h2>
                </div>
                <div fxLayout="column" class="w-full p-gutter">
                  <div fxFlex="auto" fxLayout="column">
                    <blockquote class="m-0 mb-4">
                      <p>
                        Provides a quick overview of all resources associated with this service,
                        grouped by device. Use this summary to understand how many resources are
                        new, existing, or conflicted before resolving details below.
                      </p>
                    </blockquote>
                    <div fxLayout="column">
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div
                          class="bg-app-bar px-6 h-16 border-b left-0 w-full"
                          fxLayout="row"
                          fxLayoutAlign="space-between center"
                        >
                          <div fxLayout="row" fxLayoutAlign="start center" class="w-full">
                            <h2
                              class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l"
                              fxFlex="none"
                              fxHide.xs
                            >
                              <span>Summary</span>
                            </h2>
                            <div
                              class="bg-card rounded-full border px-4"
                              fxFlex.lt-md="auto"
                              fxHide.xs
                              fxLayout="row"
                              fxLayoutAlign="start center"
                              style="width: 40%"
                            >
                              <ic-icon [icIcon]="icSearch" size="20px"></ic-icon>
                              <input
                                class="px-4 py-3 border-0 outline-none w-full bg-transparent"
                                placeholder="Search by resource type..."
                                type="text"
                                (input)="searchResource(job, $event.target.value)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div fxLayout="column">
                        <ng-container *ngIf="!job.ResourceGroupedData; else summaryDetail">
                          <div fxLayout="row" class="mt-4" fxFlex>
                            <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
                              <mat-progress-spinner
                                strokeWidth="4"
                                diameter="60"
                                mode="indeterminate"
                                color="primary"
                              ></mat-progress-spinner>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #summaryDetail>
                          <div class="mt-2 resourceCard">
                            <div class="card overflow-hidden rounded-lg">
                              <div fxLayout="row" fxLayoutAlign="center center">
                                <apx-chart
                                  [series]="job.jobStatusChartData.series"
                                  [chart]="job.jobStatusChartData.chart"
                                  [labels]="job.jobStatusChartData.labels"
                                  [legend]="job.jobStatusChartData.legend"
                                  [colors]="job.jobStatusChartData.colors"
                                >
                                </apx-chart>
                              </div>
                            </div>
                            <div
                              *ngFor="let resource of getResourcesSummary(job)"
                              class="card overflow-hidden rounded-lg"
                            >
                              <div
                                class="p-4 text-center hover:bg-hover trans-ease-out cursor-pointer relative"
                                matRipple
                              >
                                <img
                                 loading="lazy"
                                 decoding="async"
                                  [src]="resource.ResourceImage || 'assets/default/Custom/resources.svg'"
                                  onError="this.src='assets/default/Custom/resources.svg'"
                                  class="resource-summary-icon h-20 w-20 mx-auto"
                                />

                                <h2 class="title mb-1 mt-3">
                                  {{ resource.ResourceType }}
                                  <span class="blue-text" matTooltip="Count of Resources"
                                    ><p>({{ resource?.Resources.length }})</p></span
                                  >
                                </h2>
                                <div fxLayout="row" class="my-0" fxLayoutAlign="center center">
                                  <span
                                    class="bg-grey small-label text-center text-warn ml-1 rounded-full cursor"
                                    matTooltip="Count of Conflict Resources"
                                  >
                                    <p>{{ resource.ConflictCount }}</p>
                                  </span>
                                  <span
                                    class="bg-grey small-label text-center text-amber ml-1 rounded-full cursor"
                                    matTooltip="Count of Skip Resources"
                                  >
                                    <p>{{ resource.SkipCount }}</p>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mt-4 w-full">
                <div class="border-b py-4 px-6" fxLayout="row" fxLayoutAlign="start center">
                  <h2 class="m-0 title">Conflict Status by Resource</h2>
                </div>
                <div fxLayout="column" class="w-full p-gutter">
                  <div fxFlex="auto" fxLayout="column">
                    <blockquote class="m-0 mb-4">
                      <p>
                        Lists each conflicted resource and its current status. You can open the Diff view to compare the configurations
                        in detail before deciding.
                      </p>
                    </blockquote>
                    <div fxLayout="column">
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div
                          class="bg-app-bar px-6 h-16 border-b left-0 w-full"
                          fxLayout="row"
                          fxLayoutAlign="space-between center"
                        >
                          <div fxLayout="row" fxLayoutAlign="start center" class="w-full">
                            <h2
                              class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l"
                              fxFlex="none"
                              fxHide.xs
                            >
                              <span>Status By Resources</span>
                            </h2>
                            <div class="bg-card shadow rounded-full w-1/3 flex items-center ml-2">
                              <ic-icon
                                [icon]="icSearch"
                                class="text-secondary p-2"
                                size="24px"
                              ></ic-icon>
                              <input
                                (input)="filterConfiguartionResource(job, $event.target.value)"
                                class="w-full outline-none placeholder-black bg-transparent h-8"
                                placeholder="Search by resource type"
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <table class="w-full mat-table">
                        <thead>
                          <tr class="mat-header-row">
                            <th class="uppercase mat-header-cell align-left">Resource Name</th>
                            <th class="uppercase mat-header-cell align-left">Target Name</th>
                            <th class="uppercase mat-header-cell align-left">Status</th>
                            <th class="uppercase mat-header-cell align-left">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container
                            *ngFor="
                              let resource of getConfiguartionResources(job);
                              let resourceIndex = index
                            "
                          >
                            <tr class="mat-row">
                              <td class="mat-cell">
                                <div fxLayout="row" fxLayoutAlign="start start">
                                  <span class="font-medium avi-link text-over-flow">
                                    <b>
                                      <span>
                                        <span class="primary">{{
                                          resource.SourceResource.CollectionName
                                        }}</span
                                        >:
                                        {{ resource.SourceResource.CollectionEntryName }}
                                      </span>
                                    </b>
                                  </span>
                                </div>
                              </td>
                              <td class="mat-cell">
                                <div fxLayout="row" fxLayoutAlign="start start">
                                  <span class="font-medium avi-link text-over-flow">
                                    <b>
                                      <span>
                                        <span class="primary">{{
                                          resource.TargetResource.CollectionName
                                        }}</span
                                        >:
                                        {{ resource.TargetResource.CollectionEntryName }}
                                      </span>
                                    </b>
                                  </span>
                                </div>
                              </td>
                              <td class="mat-cell">
                                <button
                                  *ngIf="
                                    resource.TargetResource.ResourceState ===
                                    ResourceSate.ConflictDetected
                                  "
                                  type="button"
                                  mat-raised-button
                                  color="warn"
                                  class="equal-width-button"
                                >
                                  Conflict
                                </button>
                                <button
                                  type="button"
                                  mat-raised-button
                                  class="bg-amber text-white equal-width-button"
                                  *ngIf="
                                    resource.TargetResource.ResourceState === ResourceSate.Skipped
                                  "
                                >
                                  Skip
                                </button>
                              </td>
                              <td class="mat-cell">
                                <button
                                  mat-raised-button
                                  color="primary"
                                  type="button"
                                  (click)="
                                    onClickResourceConfiguration(job, resource, resourceIndex)
                                  "
                                >
                                  View Details
                                  <mat-icon class="mat-icon-rtl-mirror">
                                    {{
                                      job['expandedConfigurationIndex'] === resourceIndex
                                        ? 'expand_more'
                                        : 'chevron_right'
                                    }}
                                  </mat-icon>
                                </button>
                              </td>
                            </tr>
                            <tr
                              class="mat-row bg-base"
                              *ngIf="job['expandedConfigurationIndex'] === resourceIndex"
                            >
                              <td class="mat-cell w-full" colspan="4">
                                <div
                                  class="example-element-detail w-full p-4 mb-4"
                                  fxLayout="column"
                                >
                                  <div fxLayout="column" style="height: 500px">
                                    <div fxLayout="column" class="mt-2" style="height: 100%">
                                      <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-tab-group
                                          class="vex-tabs border-0 card"
                                          fxFlex="auto"
                                          [selectedIndex]="job.configurationSelectedIndex"
                                          (selectedIndexChange)="
                                            onSelectConfigurationTab($event, job)
                                          "
                                        >
                                          <mat-tab label="Tree View">
                                            <div fxLayout="row" class="card">
                                              <div fxFlex="50" class="border-r">
                                                <div fxLayout="column">
                                                  <div
                                                    class="border-b py-4 px-6"
                                                    fxLayout="row"
                                                    fxLayoutAlign="start center"
                                                  >
                                                    <h2 class="m-0 title">Current Config (Source)</h2>
                                                  </div>
                                                  <div
                                                    fxLayout="row"
                                                    class="overflow-auto"
                                                    style="height: 390px"
                                                  > 
                                                    <inventory-tree
                                                      #targetCollectionTreeView
                                                      [isNeedVerticalMargin]="true"
                                                      [isShowFilter]="false"
                                                      [showAuditFields]="true"
                                                      [defaultAudit]="getDefaultAudit(job)"
                                                      [showCSPFields]="false"
                                                      [isInventory]="false"
                                                      [isCheckbox]="false"
                                                      [onlyMandatory]="false"
                                                      [startWithChild]="true"
                                                      [showResourceStateLabel]="false"
                                                      [IsCollectionEntryAttributeId]="true"
                                                      [BlueprintCollections]="job.SourceInventory.resultBlueprintCollections"
                                                    >
                                                    </inventory-tree>
                                                  </div>
                                                </div>
                                              </div>
                                              <div fxFlex="50" class="border-l">
                                                <div fxLayout="column">
                                                  <div
                                                    class="border-b py-4 px-6"
                                                    fxLayout="row"
                                                    fxLayoutAlign="start center"
                                                  >
                                                    <h2 class="m-0 title">Configuration after changed applied (Target)</h2>
                                                  </div>
                                                  <div
                                                    fxLayout="row"
                                                    class="overflow-auto"
                                                    style="height: 390px"
                                                  >
                                                    <inventory-tree
                                                      #targetCollectionTreeView
                                                      [isNeedVerticalMargin]="true"
                                                      [isShowFilter]="false"
                                                      [showAuditFields]="true"
                                                      [defaultAudit]="getDefaultAudit(job)"
                                                      [showCSPFields]="false"
                                                      [isInventory]="false"
                                                      [isCheckbox]="false"
                                                      [onlyMandatory]="false"
                                                      [startWithChild]="true"
                                                      [IsCollectionEntryAttributeId]="true"
                                                      [BlueprintCollections]="job.TargetInventory.resultBlueprintCollections"
                                                    >
                                                    </inventory-tree>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </mat-tab>
                                          <mat-tab label="Code">
                                            <ng-container *ngIf="!job.configurationLoader">
                                              <div fxLayout="row" class="mt-4 ml-4">
                                                <mat-slide-toggle
                                                  fxLayoutAlign="end end"
                                                  fxFlex
                                                  color="primary"
                                                  (change)="onToggleChangeCode(job, $event)"
                                                >
                                                  <span class="">Seprate Scroll</span>
                                                </mat-slide-toggle>
                                              </div>
                                              <div fxLayout="column" class="w-full">
                                                <div class="overflow-y-auto" fxFlex="auto">
                                                  <ng-container
                                                    *ngIf="job.isEditorShowSeprateCode; else diff"
                                                  >
                                                    <div fxLayout="row" fxFlex="100" class="card">
                                                      <div fxFlex="50">
                                                        <div fxLayout="column">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Current Config (Source)</h2>
                                                          </div>
                                                          <ngx-monaco-editor
                                                            style="height: 400px"
                                                            [options]="editorOptions"
                                                            [(ngModel)]="job.SourceCode"
                                                            (init)="editorInit($event)"
                                                          >
                                                          </ngx-monaco-editor>
                                                        </div>
                                                      </div>
                                                      <div fxFlex="50">
                                                        <div fxLayout="column">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Configuration after changed applied (Target)</h2>
                                                          </div>
                                                          <ngx-monaco-editor
                                                            style="height: 400px"
                                                            [options]="editorOptions"
                                                            [(ngModel)]="job.TargetCode"
                                                            (init)="editorInit($event)"
                                                          >
                                                          </ngx-monaco-editor>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </ng-container>
                                                  <ng-template #diff>
                                                    <div
                                                      fxLayout="column"
                                                      fxLayoutAlign="start start"
                                                      class="w-full"
                                                    >
                                                      <div fxLayout="row" class="card w-full">
                                                        <div fxFlex="50">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Current Config (Source)</h2>
                                                          </div>
                                                        </div>
                                                        <div fxFlex="50">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Configuration after changed applied (Target)</h2>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <ngx-monaco-diff-editor
                                                        [options]="editorOptions"
                                                        [original]="job.SourceCode"
                                                        [modified]="job.TargetCode"
                                                        (init)="editorInit($event)"
                                                        class="w-full"
                                                        style="height: 400px"
                                                      ></ngx-monaco-diff-editor>
                                                    </div>
                                                  </ng-template>
                                                </div>
                                              </div>
                                            </ng-container>
                                            <div
                                              fxLayout="row"
                                              class="mt-4"
                                              fxFlex
                                              *ngIf="job.configurationLoader || loadEditor"
                                            >
                                              <div
                                                fxLayout="row"
                                                fxLayoutAlign="space-around start"
                                                fxFlex
                                              >
                                                <mat-progress-spinner
                                                  strokeWidth="4"
                                                  diameter="60"
                                                  mode="indeterminate"
                                                  color="primary"
                                                ></mat-progress-spinner>
                                              </div>
                                            </div>
                                          </mat-tab>
                                          <mat-tab label="CLI">
                                            <ng-container *ngIf="!job.cliLoader">
                                              <div fxLayout="row" class="mt-4 ml-4">
                                                <mat-slide-toggle
                                                  fxLayoutAlign="end end"
                                                  fxFlex
                                                  color="primary"
                                                  (change)="onToggleChangeCli(job, $event)"
                                                >
                                                  <span class="">Seprate Scroll</span>
                                                </mat-slide-toggle>
                                              </div>
                                              <div fxLayout="column" class="w-full">
                                                <div class="overflow-y-auto" fxFlex="auto">
                                                  <ng-container
                                                    *ngIf="job.isEditorShowSeprateCli; else diff"
                                                  >
                                                    <div fxLayout="row" fxFlex="100" class="card">
                                                      <div fxFlex="50">
                                                        <div fxLayout="column">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Current Config (Source)</h2>
                                                          </div>
                                                          <ngx-monaco-editor
                                                            style="height: 400px"
                                                            [options]="editorOptions"
                                                            [(ngModel)]="job.SourceCLICode"
                                                            (init)="editorInit($event)"
                                                          >
                                                          </ngx-monaco-editor>
                                                        </div>
                                                      </div>
                                                      <div fxFlex="50">
                                                        <div fxLayout="column">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Configuration after changed applied (Target)</h2>
                                                          </div>
                                                          <ngx-monaco-editor
                                                            style="height: 400px"
                                                            [options]="editorOptions"
                                                            [(ngModel)]="job.TargetCLICode"
                                                            (init)="editorInit($event)"
                                                          >
                                                          </ngx-monaco-editor>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </ng-container>
                                                  <ng-template #diff>
                                                    <div
                                                      fxLayout="column"
                                                      fxLayoutAlign="start start"
                                                      class="w-full"
                                                    >
                                                      <div fxLayout="row" class="card w-full">
                                                        <div fxFlex="50">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Current Config (Source)</h2>
                                                          </div>
                                                        </div>
                                                        <div fxFlex="50">
                                                          <div
                                                            class="border-b py-4 px-6"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                          >
                                                            <h2 class="m-0 title">Configuration after changed applied (Target)</h2>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <ngx-monaco-diff-editor
                                                        [options]="editorOptions"
                                                        [original]="job.SourceCLICode"
                                                        [modified]="job.TargetCLICode"
                                                        (init)="editorInit($event)"
                                                        class="w-full"
                                                        style="height: 400px"
                                                      ></ngx-monaco-diff-editor>
                                                    </div>
                                                  </ng-template>
                                                </div>
                                              </div>
                                            </ng-container>
                                            <div
                                              fxLayout="row"
                                              class="mt-4"
                                              fxFlex
                                              *ngIf="job.cliLoader || loadEditor"
                                            >
                                              <div
                                                fxLayout="row"
                                                fxLayoutAlign="space-around start"
                                                fxFlex
                                              >
                                                <mat-progress-spinner
                                                  strokeWidth="4"
                                                  diameter="60"
                                                  mode="indeterminate"
                                                  color="primary"
                                                ></mat-progress-spinner>
                                              </div>
                                            </div>
                                          </mat-tab>
                                        </mat-tab-group>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </inventory-card-full-width>
  </div>
</ng-template>
